import NetworkCall from "network/networkCall";
import Request from "network/request";

export class RecruiterActivity {
  static async weeklySummary(clientId, recruiterId, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.getRecruiterWeeklySummary(clientId, recruiterId),
      useLoading,
      false,
    );
  }

  static async weeklyCandidates(
    clientId,
    recruiterId,
    metricKey,
    useLoading = true,
  ) {
    return NetworkCall.fetch(
      Request.v2.getRecruiterWeeklyCandidates(clientId, recruiterId, metricKey),
      useLoading,
      false,
    );
  }

  static async monthlyOfferMetrics(clientId, recruiterId, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.getRecruiterMonthlyOfferMetrics(clientId, recruiterId),
      useLoading,
      false,
    );
  }

  static async monthlyProgress(clientId, recruiterId, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.getRecruiterMonthlyProgress(clientId, recruiterId),
      useLoading,
      false,
    );
  }

  static async monthlyHires(clientId, recruiterId, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.getRecruiterMonthlyHires(clientId, recruiterId),
      useLoading,
      false,
    );
  }

  static async monthlyBillings(clientId, recruiterId, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.getRecruiterMonthlyBillings(clientId, recruiterId),
      useLoading,
      false,
    );
  }

  static async tasks(clientId, recruiterId, params, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.getRecruiterTasks(clientId, recruiterId, params),
      useLoading,
      false,
    );
  }

  static async getPipelineCandidates(
    clientId,
    recruiterId,
    params,
    useLoading = false,
  ) {
    return NetworkCall.fetch(
      Request.v2.getPipelineCandidates(clientId, recruiterId, params),
      useLoading,
    );
  }

}
